export const ADMIN_WITHDRAWALS_HISTORY_VIEW_ROUTE_NAME = Symbol('admin.withdrawals-history.view');

export const WITHDRAWALS_HISTORY_ITEM_URL = 'admin/affiliate_cashouts/approved_and_declined_history/:id';
export const WITHDRAWALS_HISTORY_ITEM_QUERY_KEY = 'withdrawals-history.item';
